module.exports = __webpack_public_path__ + "static/img/gxhdz53.23573f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxhdz53.png
// module id = fq9O
// module chunks = 73